module.exports = __webpack_public_path__ + "img/客服@2x.2b9fc7a9.png";